import React from "react"
import { $createHeadingNode, $createQuoteNode } from "@lexical/rich-text"
import { $wrapNodes } from "@lexical/selection"
import { $createCodeNode } from "@lexical/code"
import { $createParagraphNode, $getSelection, $isRangeSelection } from "lexical"

import { ArrowDown } from "@mos-cat/ds-icons"

import { ActionsPopover, Button, Tooltip } from "@dit/core-frontend"

import { Box, Text } from "@mos-cat/ds"
import { buttonProps } from "../buttonProps"
import { blockTypeToBlockName } from "./BlockTypeToBlockName"

export const BlockFormatDropDown = ({ editor, editorRef, value, blockType, ref }) => {
  const formatParagraph = () => {
    if (blockType !== "paragraph") {
      editor.update(() => {
        const selection = $getSelection()
        if ($isRangeSelection(selection)) $wrapNodes(selection, () => $createParagraphNode())
      })
    }
  }

  const formatHeading = (headingSize) => {
    if (blockType !== headingSize) {
      editor.update(() => {
        const selection = $getSelection()
        if ($isRangeSelection(selection)) {
          $wrapNodes(selection, () => $createHeadingNode(headingSize))
        }
      })
    }
  }

  const formatQuote = () => {
    if (blockType !== "quote") {
      editor.update(() => {
        const selection = $getSelection()
        if ($isRangeSelection(selection)) {
          $wrapNodes(selection, () => $createQuoteNode())
        }
      })
    }
  }

  const formatCode = () => {
    if (blockType !== "code") {
      editor.update(() => {
        const selection = $getSelection()

        if (selection !== null) {
          if (selection.isCollapsed()) {
            const codeNode = $createCodeNode()
            selection.insertNodes([codeNode])

            // Вставляем пустую строку после код-блока
            const newParagraphNode = $createParagraphNode()
            selection.insertNodes([newParagraphNode])
          } else {
            const textContent = selection.getTextContent()
            const codeNode = $createCodeNode()
            selection.insertNodes([codeNode])
            selection.insertRawText(textContent)

            // Вставляем пустую строку после код-блока
            const newParagraphNode = $createParagraphNode()
            selection.insertNodes([newParagraphNode])
          }
        }
      })
    }
  }

  function handleSelectChange(value) {
    switch (value) {
      case "paragraph":
        formatParagraph()
        break
      case "h1":
        formatHeading("h1")
        break
      case "h2":
        formatHeading("h2")
        break
      case "h3":
        formatHeading("h3")
        break
      case "h4":
        formatHeading("h4")
        break
      case "h5":
        formatHeading("h5")
        break
      case "quote":
        formatQuote()
        break
      case "code":
        formatCode()
        break
      default:
        break
    }
  }
  return (
    <ActionsPopover
      ref={ref}
      portalContainer={editorRef.current}
      content={
        <Tooltip content="Стили текста">
          <Button
            {...buttonProps}
            kind="borderless"
            vertSize="30"
            width="130px"
            display="flex"
            justifyContent="start"
            alignItems="center"
          >
            <Box display="flex" width="150px" alignItems="center" gridGap="2px">
              {blockTypeToBlockName[value]?.icon || blockTypeToBlockName["paragraph"].icon}
              <Text fontSize="fs-14">
                {" "}
                {blockTypeToBlockName[value]?.value || blockTypeToBlockName["paragraph"].value}
              </Text>
              <Text fontSize="fs-14">
                <ArrowDown />
              </Text>
            </Box>
          </Button>
        </Tooltip>
      }
    >
      {(buttonProps) => (
        <>
          {Object.keys(blockTypeToBlockName).map((type) => (
            <Button
              {...buttonProps}
              key={type.value}
              {...buttonProps}
              onClick={() => {
                handleSelectChange(type)
              }}
            >
              <Box display="flex" alignItems="center" gridGap="2px">
                {blockTypeToBlockName[type]?.icon}
                <Text>{blockTypeToBlockName[type].value}</Text>
              </Box>
            </Button>
          ))}
        </>
      )}
    </ActionsPopover>
  )
}
